module.exports = __webpack_public_path__ + "static/media/s_sf_7.04af046c.png";